<template>
  <v-card class="my-4">
    <v-card-title>
      Audiences
      <v-spacer />
      <v-btn
        icon
        title="Refresh"
        :loading="refreshing"
        @click="refresh"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-subtitle>
      Every Industry and Topic we can market to. Open one to see who we already have, what content it's
      missing, and what's booked for it.
    </v-card-subtitle>

    <v-card-text class="pb-0">
      <v-row align="center">
        <v-col
          cols="12"
          sm="auto"
        >
          <v-btn-toggle
            v-model="typeFilter"
            mandatory
            dense
          >
            <v-btn :value="0">
              All
            </v-btn>
            <v-btn :value="$enums.AUDIENCE.TYPE.INDUSTRY">
              Industries
            </v-btn>
            <v-btn :value="$enums.AUDIENCE.TYPE.TOPIC">
              Topics
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            v-model="search"
            dense
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Search audiences"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <AudienceList
      ref="list"
      :type-filter="typeFilter"
      :search="search"
    />
  </v-card>
</template>

<script>
import AudienceList from '@/components/marketing/audiences/List';

export default {
  name: 'AudiencesIndex',
  components: { AudienceList },
  data() {
    return {
      typeFilter: 0,
      search: '',
      refreshing: false
    };
  },
  methods: {
    refresh() {
      this.refreshing = true;
      this.$store
        .dispatch('audiences/getList')
        .catch((error) => this.logError(error))
        .finally(() => {
          this.refreshing = false;
        });
    }
  }
};
</script>
